import { useState } from 'react';

import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Text from 'quarks/Text';
import type { FlexProps } from 'quarks/interpolations/flex';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentAccordionItem } from 'graphqlTypes';
import type { FC } from 'react';

interface AccordionItemProps extends ContentfulComponentAccordionItem, FlexProps {
  index?: number;
}

const AccordionItem: FC<AccordionItemProps> = ({ question, answer, ...props }) => {
  const [itemOpen, setItemOpen] = useState(false);

  return (
    <Flex width="100%" flexDirection="column">
      <Flex
        paddingAll={16}
        gap="16px"
        border="1px solid"
        borderColor="gray-300"
        onClick={() => setItemOpen(!itemOpen)}
        cursor="pointer"
        onKeyDown={e => e.key === 'Enter' && setItemOpen(!itemOpen)}
        tabIndex={0}
        {...props}
      >
        <Flex gap="16px" justifyContent="space-between" width="100%">
          <Flex gap="16px">
            <Flex alignItems="center">
              <Icon id="checkmark-circle" fill={color.green[500]} size={24} />
            </Flex>
            <Text xl={{ textStyle: 'xl', fontWeight: 'extraBold' }} textStyle="md" fontWeight="extraBold">
              {question}
            </Text>
          </Flex>
          <Flex alignItems="center">
            <Icon id={itemOpen ? 'minus-circle' : 'plus-circle'} size={24} />
          </Flex>
        </Flex>
      </Flex>
      {answer && (
        <Container
          display={itemOpen ? 'block' : 'none'}
          paddingAll={40}
          border="1px solid"
          borderTop="unset"
          borderColor="gray-300"
          backgroundColor="common-white"
        >
          <Text
            display="flex"
            flexDirection="column"
            gap="16px"
            textStyle="md"
            fontWeight="regular"
            xl={{ textStyle: 'xl' }}
          >
            {richTextParser(answer)}
          </Text>
        </Container>
      )}
    </Flex>
  );
};

export default AccordionItem;
